<div class="page-wrapper" >
<div class="authentication-main" >
<div class="container-fluid" >
  <div class="row">
    <div class="col-xl-12 xl-100">
      <div class="row">	  
	   <!--<div class="text-center" style="padding:20px;"><img src="assets/images/logo.png"   /></div>	-->
        <div class="col-lg-12">
          <div class="card">           
        <div class="card-body">          		                                
			<form [formGroup]="registerForm" class="needs-validation" novalidate >
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Register</h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-md-4 mb-3">
										<label>Type *</label>	
										<select class="form-control select btn-square " formControlName="business_type" name="business_type" placeholder="" required >	
											<option value="">Select</option>
											<option value="0">Individual</option>													
											<option value="1">Sole Proprietorship</option>													
											<option value="2">Partnership Firm</option>													
											<option value="3">Limited Liability Partnership</option>
											<option value="4">Private Limited Company</option>											
											<option value="5">Limited Company</option>											
											<option value="6">Limited Liability Company</option>											
											<option value="7">C Corp</option>											
											<option value="8">S Corp</option>																						
										</select>	
											<div *ngIf="submitted  && registerForm.controls['business_type'].errors" >	
												<div *ngIf="registerForm.controls['business_type'].errors?.['required']" class="text text-danger" >Business Type is required</div>								
											</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Business Vertical Name *</label>
										<input class="form-control btn-square" type="text" formControlName="business_vertical_name" placeholder="" name="business_vertical_name"  #vendor_name required>
										<div *ngIf="submitted && registerForm.controls['business_vertical_name'].errors"  >
											<div *ngIf="registerForm.controls['business_vertical_name'].errors?.['required']" class="text text-danger">Business Vertical Name is Required</div>
										</div>
									</div>																		
								</div>                        
								   
								<div class="row">                            
									<div class="col-md-12 mb-3">
										<label >Description *</label>
										<textarea class="form-control btn-square"  rows="4" type="text" formControlName="business_vertical_description" placeholder="" name="business_vertical_description" required> </textarea>
										<div *ngIf="submitted && registerForm.controls['business_vertical_description'].errors"  >
											<div *ngIf="registerForm.controls['business_vertical_description'].errors?.['required']" class="text text-danger">Business Vertical Description is Required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Business Name *</label>
										<input class="form-control btn-square" type="text" formControlName="business_name" placeholder="" name="business_name" required (blur)="getBusinessName($event);" #business_name>
										<div *ngIf="submitted && registerForm.controls['business_name'].errors"  >
											<div *ngIf="registerForm.controls['business_name'].errors?.['required']" class="text text-danger" >Business Name is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Subdomain for Business *</label>
										<input class="form-control btn-square" type="text" formControlName="business_subdomain" placeholder="" name="business_subdomain" required (blur)="getBusinessSubdomain($event);" #business_subdomain>
										<div *ngIf="submitted && registerForm.controls['business_subdomain'].errors"  >
											<div *ngIf="registerForm.controls['business_subdomain'].errors?.['required']" class="text text-danger" >Subdomain Name is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Legal Name *</label>
										<input class="form-control btn-square" type="text" formControlName="legal_name" placeholder="" name="legal_name" required>
										<div *ngIf="submitted && registerForm.controls['legal_name'].errors"  >
											<div *ngIf="registerForm.controls['legal_name'].errors?.['required']" class="text text-danger" >Legal Name is required</div>
										</div>
									</div>
								</div> 
							</div>
						</div>	
						
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5>Address</h5>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-md-3 mb-3">
										<label>Address Line1</label>	
										<input class="form-control btn-square"  type="text" formControlName="addressline1" placeholder="" name="addressline1" >
									</div>
									<div class="col-md-3 mb-3">
										<label>Address Line2</label>	
										<input class="form-control btn-square"  type="text" formControlName="addressline2" placeholder="" name="addressline2" >
									</div>
									<div class="col-md-3 mb-3">
										<label >Street No</label>
									   <input class="form-control btn-square"  type="text" formControlName="street_no" placeholder="" name="street_no" > 	
									</div>
									<div class="col-md-3 mb-3">
										<label >Street Name</label>
										<input class="form-control btn-square"  type="text" formControlName="street_name" placeholder="" name="street_name" >                                
									</div>									
									<div class="col-md-3 mb-3">
										<label >Area *</label>
										<input class="form-control btn-square" type="text" formControlName="area_name" name="area_name" placeholder="" required>											
										<div *ngIf="submitted && registerForm.controls['area_name'].errors"  >
											<div *ngIf="registerForm.controls['area_name'].errors?.['required']" class="text text-danger">Area is Required</div>
										</div>	
									</div>
									<div class="col-md-3 mb-3">
										<label >Zip *</label>
										<input class="form-control btn-square" type="text" formControlName="zip" placeholder="" name="zip" required>                               
										<div *ngIf="submitted && registerForm.controls['zip'].errors"  >
											<div *ngIf="registerForm.controls['zip'].errors?.['required']" class="text text-danger">Zip is Required</div>
										</div>	
									</div>
									<div class="col-md-3 mb-3">
										<label >Region</label>
										<input class="form-control btn-square" type="text" formControlName="region_name" name="region_name" placeholder="" >	 
									</div>
									<div class="col-md-3 mb-3">
										<label >Province *</label>
										<select class="form-control btn-square" formControlName="stateshort" name="stateshort" placeholder=""  required (change)="getState($event);">	
											<option value="">Select</option>                                                                   
											<option *ngFor="let state of countryProvinces"  value={{state.shortname}}>{{state.longname}}</option> 
										</select>	 
										<div *ngIf="submitted && registerForm.controls['stateshort'].errors"  >
											<div *ngIf="registerForm.controls['stateshort'].errors?.['required']" class="text text-danger" >Province is required</div>
										</div>	
									</div>
									<div class="col-md-3 mb-3">
										<label >Country</label>
										<input class="form-control btn-square" type="text"  placeholder="" name="country" value={{country}}   [disabled]=true>                                
									</div>
								</div>
							</div>			
						</div>
						<div class="card">
							<div class="card-header" style="padding:15px;background-color:#e5e5e5">
								<h5 >Point of Contact</h5>
							</div>
							<div class="card-body">
								<div class="row">
									
									<div class="col-md-4 mb-3">
										<label >First Name *</label>
										<input class="form-control btn-square" type="text" formControlName="admin_first_name" placeholder="" name="admin_first_name" required>
										<div *ngIf="submitted && registerForm.controls['admin_first_name'].errors">
											<div *ngIf="registerForm.controls['admin_first_name'].errors?.['required']" class="text text-danger" >First Name is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Last Name</label>
										<input class="form-control btn-square" type="text" formControlName="admin_last_name" placeholder="" name="admin_last_name" >
									</div>
									<div class="col-md-4 mb-3">
										<label >Title *</label>
										<input class="form-control btn-square" type="text" formControlName="admin_title" placeholder="" name="admin_title"  required>
										<div *ngIf="submitted && registerForm.controls['admin_title'].errors" >
											<div *ngIf="registerForm.controls['admin_title'].errors?.['required']" class="text text-danger"  >Title is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Gender *</label>
										<select class="form-control btn-square" formControlName="admin_gender" name="admin_gender" placeholder="" required>	
											<option value="">Select</option>                                                                   
											<option value="1">Male</option>                                                                   
											<option value="2">Female</option>                                                                   
											<option value="3">Others</option>                                                                   						
										</select>
										<div *ngIf="submitted && registerForm.controls['admin_gender'].errors"  >
											<div *ngIf="registerForm.controls['admin_gender'].errors?.['required']" class="text text-danger" >Gender is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Date of Birth *</label>
										<input class="form-control btn-square" type="date" formControlName="admin_dob" placeholder="" name="admin_dob"  min="{{minDobString}}" max="{{maxDobString}}" required>
										<div *ngIf="submitted && registerForm.controls['admin_dob'].errors"  >
											<div *ngIf="registerForm.controls['admin_dob'].errors?.['required']" class="text text-danger">Date of birth is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Phone *</label>
										<input class="form-control btn-square" type="number" formControlName="admin_phone" placeholder="" name="admin_phone"  required>
										<div *ngIf="submitted && registerForm.controls['admin_phone'].errors"  >
											<div *ngIf="registerForm.controls['admin_phone'].errors?.['required']" class="text text-danger" >Phone is required</div>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<label >Email ID *</label>
										<input class="form-control btn-square" type="email" formControlName="admin_email" placeholder="" name="admin_email"  required (blur)="getEmail($event)" #email1>
										<div *ngIf="submitted"  >
											<div *ngIf="registerForm.controls['admin_email'].errors?.['required']" class="text text-danger">Email address is required</div>
											<div *ngIf="registerForm.controls['admin_email'].errors?.['pattern']" class="text text-danger" >Email is Invalid</div>
										</div>
									</div>									
								</div>
							</div>
							<div class="card-footer" >
								<button class="btn btn-primary btn-sm" type="submit" placement="top" (click)="onSubmit();" >Register</button>
							</div>							 
						</div>								
						
					<!--	<a routerLink="/master/ViewVendor" class="btn btn-outline-light btn-pill btn-air-light btn-sm txt-dark" style="background-color:#FFFFFF">Cancel</a>-->
					<!--	<button class="btn btn-outline-light btn-pill btn-air-light btn-sm txt-dark" type="submit" placement="top" (click)="test();" style="background-color:#FFFFFF">Test</button>&nbsp;&nbsp;-->

						   
                    </form>
        </div>		
		</div>
		</div>						
		</div>
		</div>        
		</div>   
  
  
  
  
  
  
  </div>

  
</div>

</div>